(function () {
  const wrapper = document.querySelector(".multicolumn_infinite-list__wrapper");
  if (!wrapper) return;
  
  const items = Array.from(wrapper.children);
  
  // Duplicar itens apenas uma vez
  items.forEach((item) => {
    const clone = item.cloneNode(true);
    wrapper.appendChild(clone);
  });
})();